<template>
    <div class="sms-platform">
      <a-alert class="marquee" banner>
        <div class="marquee-content">短信接码平台仅限波场TRC20-USDT支付</div>
      </a-alert>
  
      <div class="container">
        <a-row :gutter="16">
          <a-col :xs="24" :md="16">
            <a-row :gutter="[16, 16]">
              <a-col :span="24" v-for="(number, index) in numbers" :key="index">
                <a-card class="number-card">
                  <div class="card-content">
                    <div class="number-info-wrapper">
                      <a-tag :color="number.country === '美国' ? '#1890ff' : '#52c41a'">
                        {{ number.country }}
                      </a-tag>
                      <span class="number">{{ number.phone }}</span>
                      <div class="number-info">
                        <span class="operator">运营商: {{ number.operator }}</span>
                        <span class="expiry">有效期: 15分钟</span>
                      </div>
                    </div>
                    <div class="actions">
                      <a-button type="primary" size="small" @click="copyNumber(number.phone)">复制号码</a-button>
                      <a-button type="success" style="    color: #fff;background-color: #198754;border-color: #198754;line-height:1.5" size="small" @click="getSms(number)" :loading="number.loading">
                        {{ number.loading ? '处理中...' : '支付查看短信' }}
                      </a-button>
                    </div>
                  </div>
                </a-card>
              </a-col>
            </a-row>
          </a-col>

          <a-col :xs="24" :md="8">
            <a-card class="number-card" title="使用指南">
               
                <div class="guide-steps">
                    <h2>使用指南</h2>
                <div v-for="(step, index) in guideSteps" :key="index" class="step-item">
                   
                    <p class="step-ite"> {{ index + 1 }}. {{ step }}</p>
                </div>
                </div>
                
                <a-alert type="warning" class="mt-3 warning-card">
            
                    <h3>注意事项</h3>
                    <div>
                        <ul class="notes-list">
                        <li>验证码保存15分钟，因为大部分验证码有效期是10分钟</li>
                        <li>几百个号码库，公平起见每次仅随机显示中外号码各七个，刷新页面更换号码</li>
                        <li>每次查看验证码需要支付0.5USDT,由于号码是公共号码不能保证唯一使用</li>
                        </ul>
                    </div>
               
            </a-alert> 
                <!-- 注意事项部分保持不变 -->
           
        </a-card>
        </a-col>
  
          
        </a-row>
      </div>
    </div>
  </template>
  
  <script>
  import { message } from 'ant-design-vue';
  import { ref, onMounted } from 'vue';
  import { addOrder } from '../util/api'; 
  import { useRouter } from 'vue-router';
  export default {
    name: 'PhoneCode',
    setup() {
      const numbers = ref([]);
      const guideSteps = ref([
        '选择国家/地区',
        '复制号码到需要验证的平台',
        '点击获取短信查看验证码支付0.5USDT'
      ]);
      const router = useRouter();
      const referral_code = ref('');
  
      // 生成随机号码
      const generateNumbers = () => {
        const usaOperators = ['AT&T', 'Verizon', 'T-Mobile'];
        const chinaOperators = ['中国移动', '中国联通', '中国电信'];
        const newNumbers = [];
  
        // 生成美国号码
        for (let i = 0; i < 7; i++) {
          const randomNumberUSA = '+1' + Math.floor(Math.random() * 10000000000);
          const operatorUSA = usaOperators[Math.floor(Math.random() * usaOperators.length)];
          
          newNumbers.push({
            country: '美国',
            phone: randomNumberUSA,
            operator: operatorUSA,
            loading: false
          });
        }
  
        // 生成中国号码
        for (let i = 0; i < 7; i++) {
          const randomNumberChina = '13' + Math.floor(Math.random() * 1000000000).toString().padStart(9, '0');
          const operatorChina = chinaOperators[Math.floor(Math.random() * chinaOperators.length)];
          
          newNumbers.push({
            country: '中国',
            phone: randomNumberChina,
            operator: operatorChina,
            loading: false
          });
        }
  
        numbers.value = newNumbers;
      };
  
      // 复制号码
      const copyNumber = (phone) => {
        navigator.clipboard.writeText(phone).then(() => {
          message.success('号码已复制到剪贴板');
        }).catch(() => {
          message.error('复制失败，请手动复制');
        });
      };
  
      // 获取短信
      const getSms = async (number) => {
        number.loading = true;
       
            
            let str = getCurrentDateTime() + Math.floor(Math.random() * 100000).toString().padStart(6, '0');
            let data = {
                price:0.5,
                inputNumber:1,
                inputGT:number.phone,
                orderNo: str,
                title:"获取手机验证码",
                referral_code:referral_code.value
            }
          
        try {
          
          await addOrder(data)

          router.push({ name: 'Payment', params: { data: JSON.stringify(data) } });
        } catch (error) {
          console.error('获取短信失败:', error);
          message.error('获取短信失败，请稍后重试');
        } finally {
          number.loading = false;
        }
      };

      const getCurrentDateTime =() =>  {
            const date = new Date();
            const year = date.getFullYear();
            const month = ("0" + (date.getMonth() + 1)).slice(-2);
            const day = ("0" + date.getDate()).slice(-2);
            const hours = ("0" + date.getHours()).slice(-2);
            const minutes = ("0" + date.getMinutes()).slice(-2);
            const seconds = ("0" + date.getSeconds()).slice(-2);
            return `${year}${month}${day}${hours}${minutes}${seconds}`;
        }
  
      // 初始化生成号码
      onMounted(() => {
        const params = new URLSearchParams(window.location.search);
            // 获取推荐码
        referral_code.value = params.get("code");
        
        generateNumbers();
      });
  
      return {
        numbers,
        guideSteps,
        copyNumber,
        getSms
      };
    }
  };
  </script>
  
  <style scoped>
  .sms-platform {
    background-color: #f8f9fa;
    min-height: 100vh;
    padding: 20px;
  }
  
  .marquee {
    margin-bottom: 20px;
  }
  
  .marquee-content {
    animation: scroll 10s linear infinite;
    white-space: nowrap;
    color: #007bff;
    font-size: 18px;
    font-weight: bold;
  }
  
  @keyframes scroll {
    0% { transform: translateX(110%); }
    100% { transform: translateX(-110%); }
  }
  
  .number-card {
    transition: all 0.3s;
    position:relative;
    display: flex;
    flex-direction: column;
    min-width: 0;
    word-wrap: break-word;
    background-color: #fff;
    background-clip: border-box;
    border: 1px solid rgba(0,0,0,.125);
    border-radius: .25rem;
  }
  
  .number-card:hover {
    transform: translateY(-3px);
    box-shadow: 0 5px 15px rgba(0, 0, 0, 0.1);
  }
  
  .card-content {
    padding: 1rem;
    display: flex;
    justify-content: space-between;
    align-items: center;

  }
  
  .number {
    font-size: 16px;
    font-weight: 500;
    margin-left: 8px;
  }
  .number-info-wrapper {
    flex: 1;
    min-width: 0; /* 防止内容溢出 */
    }
  .number-info {
    font-size: 12px;
    color: rgba(0, 0, 0, 0.45);
    margin-top: 4px;
  }
  
  .number-info span {
    margin-right: 12px;
  }

  .actions {
    flex-shrink: 0;
    margin-left: 16px;
    white-space: nowrap;
    }
  
  .actions button {
    margin-left: 8px;
  }
  
  .alert-title {
    font-weight: bold;
    margin-bottom: 8px;
  }
  
  .notes-list {
    font-weight:500;
    font-size: 14px;
    padding-left: 20px;
    margin-bottom: 0;
  }
  
  .notes-list li {
    margin-bottom: 4px;
  }
  
  .mt-3 {
    margin-top: 16px;
  }

  .guide-steps {
  flex: 1 1 auto;
  padding: 1rem 1rem;
}

.step-item {
    display: flex;
    flex-direction: column;
    padding-left: 0;
    margin-bottom: 0;
    border-radius: .25rem;
}
.step-ite{
    font-size: 16px;
    position: relative;
    display: block;
    color: #212529;
    text-decoration: none;
    background-color: #fff;
}

.warning-card {
    color: #664d03;
    background-color: #fff3cd;
    border-color: #ffecb5;
    position: relative;
    padding: 1rem 1rem;
    margin-bottom: 1rem;
    border: 1px solid transparent;
    border-radius: .25rem;
    margin-left: 1rem;
    margin-right: 1rem;
    margin-top: 0px;
}
  
  @media (max-width: 768px) {
    .card-content {
      flex-direction: column;
      align-items: flex-start;
    }
    
    .actions {
        margin-left: 0;
      margin-top: 12px;
      width: 100%;
      display: flex;
      justify-content: space-between;
    }
    
    .actions button {
      flex: 1;
      margin-right: 8px;
    }
    
    .actions button:last-child {
      margin-right: 0;
    }
  }
  </style>